import { Disclosure } from "@headlessui/react";
import { ChevronRight, Trash } from "lucide-react";
import ProductDraftForm from "./ProductDraftForm";

export function ProductAccordionItem({ product, onChange, onDelete, businessId, baseCurrency  }) {
  return (
    <Disclosure as="li" defaultOpen={product.isNew}>
      {({ open }) => (
        <>
          {/* Header row with separate Delete button (red) */}
          <div
            className="flex w-full items-center justify-between rounded-2xl border p-3
                       bg-white hover:bg-gray-50 transition"
          >
            <Disclosure.Button
              className="flex-1 flex items-center justify-between gap-3 focus:outline-none focus:ring-2 focus:ring-indigo-300 rounded-xl"
              aria-label={open ? "Collapse product" : "Expand product"}
            >
              <span className="font-medium">
                {product.name || <em className="text-gray-500">(untitled)</em>}
              </span>
              <div className="flex items-center gap-3 text-sm text-gray-500">
                {!product.isNew && (
                  <span className="hidden sm:inline">
                    {/* keep lightweight summary here; stock removed from form but may exist from backend */}
                    {product.price}€
                  </span>
                )}
                <ChevronRight className={`h-5 w-5 transform transition-transform ${open && "rotate-90"}`} />
              </div>
            </Disclosure.Button>

            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation(); // don’t toggle accordion
                onDelete();
              }}
              className="ml-3 btn-danger rounded-xl flex items-center gap-1 px-3 py-1.5"
              title="Delete"
            >
              <Trash size={16} />
              <span className="hidden sm:inline">Delete</span>
            </button>
          </div>

          <Disclosure.Panel className="rounded-2xl border-l border-r border-b p-4 bg-white">
            <ProductDraftForm product={product} onChange={onChange} businessId={businessId} baseCurrency={baseCurrency} />
            {/* Delete button removed from here */}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
